import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { subscribeTeamAgents } from '../data/listeners/users';

// The signed-in manager's team of agents (live). Empty for non-managers.
// Shared by the "filter by salesman" dropdown + the team-named scope banner.
export function useTeamAgents() {
  const { role, authUser } = useAuth();
  const [agents, setAgents] = useState([]);
  useEffect(() => {
    if (role !== 'manager' || !authUser?.uid) { setAgents([]); return undefined; }
    return subscribeTeamAgents({ managerUid: authUser.uid }, setAgents);
  }, [role, authUser?.uid]);
  return agents;
}
